import { useState, useEffect, useRef } from "react";
import { ActionButton, AltButton } from "../../../common/Buttons/Buttons";
import { Header } from "../../../common/Header/Header.jsx";
import { SelectPerPage } from "../../../common/Forms/Input/Input";
import {
  ExportablesDBTable,
  ExportablesPaymentTable,
  ExportablesPendingPaymentTable,
  ExportableAdministrationTable,
  ExportablesFollowUpTable,
  ExportablesLocksmithTable,
} from "../../../common/Tables/Tables";
import {
  exportanblesTableheader,
  AVPaymentHeader,
  PendingPaymentHeader,
  AdminExportableHeader,
  internalTowPaymentHeader,
  externalTowPaymentHeader,
  imageHeader,
  stageTimeHeader,
  followUpHeader,
  locksmithHeader,
} from "../../../../assets/helpers/tables";
import * as XLSX from "xlsx";
import { notify } from "../../../../assets/helpers/toast";
import { caseService } from "../../../../services/caseService";
import { servicesService } from "../../../../services/servicesService";
import {
  exportablesTypes,
  statusHeadervalues,
  caseTypeOptions,
} from "../../../../assets/helpers/options";
import {
  FilterDatePicker,
  Select,
  SearchInput,
} from "../../../common/Forms/Input/Input";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as schemas from "../../../../assets/schemas/schemas";
import { filterParams } from "../../../../assets/helpers/funciones";
import moment from "moment";
import { LoadSpinner } from "../../../common/LoadSpinner/LoadSpinner";

import "./Exportables.scss";
import { operationsRoles } from "../../../../assets/helpers/roles.js";

const itemsPerpage = [10, 25, 50, 100, 500, 1000, 2500, 5000];

export const FilterButton = (props) => {
  const { label, type, action } = props;

  if (label === "BD" && !type) {
    return <ActionButton label={label} action={() => action(label)} />;
  }
  if (label === type) {
    return <ActionButton label={label} action={() => action(label)} />;
  } else {
    return <AltButton label={label} action={() => action(label)} />;
  }
};

export const assignHeader = (type) => {
  if (type === exportablesTypes?.PAYMENT_AV) {
    return AVPaymentHeader;
  }
  if (type === exportablesTypes?.PAYMETN_INTERNAL_TOW) {
    return internalTowPaymentHeader;
  }
  if (type === exportablesTypes?.PAYMENT_EXTERNAL_TOW) {
    return externalTowPaymentHeader;
  } else {
    return exportanblesTableheader;
  }
};

export const Exportables = () => {
  const { operationsSupervisor, operationsAdmin } = operationsRoles;
  const tableRef = useRef(null);
  let user = sessionStorage.getItem("user");
  user = JSON.parse(user);

  const { watch } = useForm({
    resolver: yupResolver(schemas.filterExportableSchema()),
  });

  const [BDHeader, setBDHeader] = useState(exportanblesTableheader);
  const [sinceDate, setSinceDate] = useState(new Date());
  const [untilDate, setUntilDate] = useState(new Date());
  const [exportablesDataTable, setExportablesDataTable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    sinceDate: "",
    untilDate: "",
    isInternal: true,
    isLoading: true,
    type: "",
    caseType: "",
    search: "",
  });

  const selectType = (type) => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        type: type === "BD" ? "" : type,
        data: [],
        caseType: "",
        search: "",
      };
    });
  };

  const handleCaseType = (e) => {
    const { value } = e?.target;

    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        type: "",
        data: [],
        caseType: value,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > untilDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setSinceDate(e);
    }
  };
  const handleUntilDateChange = (e) => {
    if (e < sinceDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setUntilDate(e);
    }
  };

  const selectitemsPerpage = (event) => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * exportablesDataTable?.limit,
      };
    });
  };

  const getPendingPaymentExportables = (byMail) => {
    if (
      [exportablesDataTable?.type]?.includes(exportablesTypes?.ADMINISTRATION)
    ) {
      return null;
    }

    let params = {
      from: moment(sinceDate).format("YYYY-MM-DD"),
      to: moment(untilDate).format("YYYY-MM-DD"),
      limit: exportablesDataTable?.limit,
      page: exportablesDataTable?.page,
    };

    if (byMail) {
      params.byMail = true;
    }

    servicesService
      .getExportables(params)
      .then((response) => {
        if (response.status === 200) {
          if (byMail) {
            notify("El exportable se ha enviado por correo", "success");
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
                byMail: false,
              };
            });
          } else {
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.results,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          }
        } else {
          notify(`${response.message}` || "error", "error");
          setExportablesDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setExportablesDataTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const getLocksmithExportables = (byMail) => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    let params = {
      from: moment(sinceDate).format("YYYY-MM-DD"),
      to: moment(untilDate).format("YYYY-MM-DD"),
      page: exportablesDataTable?.page,
      limit: exportablesDataTable?.limit,
    };

    if (byMail) {
      params.byMail = true;
    }

    servicesService
      .getLocksmithExportable(params)
      .then((response) => {
        if (response.status === 200) {
          if (byMail) {
            notify("El exportable se ha enviado por correo", "success");
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
                byMail: false,
              };
            });
          } else {
            const payload = response?.data || {};
            const rows = Array.isArray(payload?.locksmithCases)
              ? payload.locksmithCases
              : [];

            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                data: rows,
                count: payload?.count ?? rows.length,
                isLoading: false,
              };
            });
          }
        } else {
          notify(`${response.message}` || "error", "error");
          setExportablesDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => {
        setExportablesDataTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const getExportablesAdmin = (byMail) => {
    if (
      ![exportablesDataTable?.type]?.includes(exportablesTypes?.ADMINISTRATION)
    ) {
      return null;
    }

    let params = {
      from: moment(sinceDate).format("YYYY-MM-DD"),
      to: moment(untilDate).format("YYYY-MM-DD"),
      perPage: exportablesDataTable?.limit,
      page: exportablesDataTable?.page,
    };

    if (byMail) {
      params.byMail = true;
    }

    servicesService
      .getExportableAdmin(params)
      .then((response) => {
        if (response.status === 200) {
          if (byMail) {
            notify("El exportable se ha enviado por correo", "success");
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
                byMail: false,
              };
            });
          } else {
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.data,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          }
        } else {
          notify(`${response.message}` || "error", "error");
          setExportablesDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setExportablesDataTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const handleSearchChange = (e) => {
    const { value } = e?.target;
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        search: value,
        page: 1,
        offset: 0,
      };
    });
  };

  const getExportables = (type, byMail) => {
    const selectedType = type ? type : exportablesDataTable?.type;

    if ([exportablesTypes?.LOCKSMITH]?.includes(selectedType)) {
      getLocksmithExportables(byMail);
      return null;
    }
    if ([exportablesTypes?.PAYMENT_PENDING]?.includes(type)) {
      getPendingPaymentExportables();
      return null;
    }
    if ([exportablesTypes?.ADMINISTRATION]?.includes(type)) {
      return null;
    }

    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    let body = {
      sinceDate: moment(sinceDate).format("YYYY-MM-DD"),
      untilDate: moment(untilDate).format("YYYY-MM-DD"),
      limit: exportablesDataTable?.limit,
      page: exportablesDataTable?.page,
      type: type ? type : exportablesDataTable?.type,
      providers: "",
    };

    let params = {
      sinceDate: moment(sinceDate).format("YYYY-MM-DD"),
      untilDate: moment(untilDate).format("YYYY-MM-DD"),
      limit: exportablesDataTable?.limit,
      offset: exportablesDataTable?.offset,
      type: type ? type : exportablesDataTable?.type,
      caseType: exportablesDataTable?.caseType,
      search: exportablesDataTable?.search,
    };

    if (params.type === exportablesTypes.FOLLOW_UP) {
      params.type = "Tracking";
    }

    if (byMail) {
      params.byMail = true;
      body.byMail = true;
    }

    if (
      [
        exportablesTypes?.PAYMETN_INTERNAL_TOW,
        exportablesTypes?.PAYMENT_EXTERNAL_TOW,
        exportablesTypes?.PAYMENT_AV,
      ].includes(type)
    ) {
      if ([exportablesTypes?.PAYMENT_AV].includes(type)) {
        if (body.providers === "") {
          delete body.providers;
        } else {
          let provider = [];
          provider.push(body.providers);
          body.providers = provider;
        }
        if (body.paymentStatus === "") {
          delete body.paymentStatus;
        }
        delete body.type;

        caseService
          .getAVPayments(body)
          .then((response) => {
            if (response.status === 200) {
              if (byMail) {
                notify("El exportable se ha enviado por correo", "success");
                setExportablesDataTable((prevState) => {
                  return {
                    ...prevState,
                    isLoading: false,
                    byMail: false,
                  };
                });
              } else {
                setExportablesDataTable((prevState) => {
                  return {
                    ...prevState,
                    data: response?.data?.services,
                    count: response?.data?.count,
                    isLoading: false,
                  };
                });
              }
            } else {
              notify(`${response.message}` || "error", "error");
              setExportablesDataTable((prevState) => {
                return {
                  ...prevState,
                  isLoading: false,
                };
              });
            }
          })
          .catch(() => {
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          });
      }

      if ([exportablesTypes?.PAYMETN_INTERNAL_TOW].includes(type)) {
        if (body.paymentStatus === "") {
          delete body.paymentStatus;
        }
        if (body.providers === "") {
          delete body.providers;
        } else {
          let provider = [];
          provider.push(body.providers);
          body.providers = provider;
        }
        delete body.type;
        caseService
          .getInternalTowsPayments(body)
          .then((response) => {
            if (response.status === 200) {
              if (byMail) {
                notify("El exportable se ha enviado por correo", "success");
                setExportablesDataTable((prevState) => {
                  return {
                    ...prevState,
                    isLoading: false,
                    byMail: false,
                  };
                });
              } else {
                setExportablesDataTable((prevState) => {
                  return {
                    ...prevState,
                    data: response?.data?.services,
                    count: response?.data?.count,
                    isLoading: false,
                  };
                });
              }
            } else {
              notify(`${response.message}` || "error", "error");
              setExportablesDataTable((prevState) => {
                return {
                  ...prevState,
                  isLoading: false,
                };
              });
            }
          })
          .catch(() => {
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          });
      }

      if ([exportablesTypes?.PAYMENT_EXTERNAL_TOW].includes(type)) {
        if (body.providers === "") {
          body.providers = [];
        }
        delete body.type;
        caseService
          .getExternalTowsPayments(body)
          .then((response) => {
            if (response.status === 200) {
              if (byMail) {
                notify("El exportable se ha enviado por correo", "success");
                setExportablesDataTable((prevState) => {
                  return {
                    ...prevState,
                    isLoading: false,
                    byMail: false,
                  };
                });
              } else {
                setExportablesDataTable((prevState) => {
                  return {
                    ...prevState,
                    data: response?.data?.services,
                    count: response?.data?.count,
                    isLoading: false,
                  };
                });
              }
            } else {
              notify(`${response.message}` || "error", "error");
              setExportablesDataTable((prevState) => {
                return {
                  ...prevState,
                  isLoading: false,
                };
              });
            }
          })
          .catch(() => {
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          });
      }
    } else {
      caseService
        .getExportables(filterParams(params))
        .then((response) => {
          if (response.status === 200) {
            if (byMail) {
              notify("El exportable se ha enviado por correo", "success");
              setExportablesDataTable((prevState) => {
                return {
                  ...prevState,
                  isLoading: false,
                  byMail: false,
                };
              });
            } else {
              setExportablesDataTable((prevState) => {
                let data = [...exportablesDataTable?.data];
                if (
                  [
                    exportablesTypes?.PAYMETN_INTERNAL_TOW,
                    exportablesTypes?.PAYMENT_AV,
                    exportablesTypes?.PAYMENT_EXTERNAL_TOW,
                  ].includes(params?.type)
                ) {
                  data = response?.data?.services;
                }
                if (
                  [exportablesTypes?.FOLLOW_UP].includes(type) ||
                  !params?.type
                ) {
                  updateHeaderValues(response?.data?.cases);
                  let columns = getHeaderColumns(response?.data?.cases);
                  data = polutaleEmptyData(
                    response?.data?.cases,
                    columns?.services,
                    columns?.payments
                  );
                }

                return {
                  ...prevState,
                  data: data,
                  count: response?.data?.count,
                  isLoading: false,
                };
              });
            }
          } else {
            notify(`${response.message}` || "error", "error");
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setExportablesDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    }

    return true;
  };

  const exportTable = (type) => {
    if ([exportablesTypes?.PAYMENT_PENDING]?.includes(type)) {
      getPendingPaymentExportables(true);
    }
    if ([exportablesTypes?.ADMINISTRATION]?.includes(type)) {
      getExportablesAdmin(true);
    }
    getExportables(exportablesDataTable?.type, true);
  };

  useEffect(() => {
    getExportables(exportablesDataTable?.type);
    getExportablesAdmin();
  }, [
    exportablesDataTable?.page,
    exportablesDataTable?.offset,
    exportablesDataTable?.limit,
    exportablesDataTable?.type,
    exportablesDataTable?.sinceDate,
    exportablesDataTable?.untilDate,
    exportablesDataTable?.caseType,
    sinceDate,
    untilDate,
  ]);

  const getHeaderColumns = (data) => {
    let services = 0;
    let payments = 0;

    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.services?.length >= services) {
        services = data[i]?.services?.length;
      }

      for (let j = 0; j < data[i]?.services?.length; j++) {
        if (data[i]?.services[j]?.payments?.length > payments) {
          payments = data[i]?.services[j]?.payments?.length;
        }
      }
    }
    return {
      services: services,
      payments: payments,
    };
  };

  const AddHeaderPerRole = () => {
    if (![operationsSupervisor].includes(user?.roles?.[0]?.code)) {
      return stageTimeHeader;
    } else {
      return [];
    }
  };

  // Create dynamic
  const updateHeaderValues = (data) => {
    let columns = getHeaderColumns(data);

    let newHeader = [...exportanblesTableheader];
    let hide = false;

    for (let i = 0; i < columns?.services; i++) {
      newHeader.push({
        name: `Servicio Prestado ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Estatus Servicio ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      if (i === 0) {
        newHeader.push({
          name: `Motivo 1° servicio grúa`,
          value: "",
          sortable: false,
          hide: hide,
        });
      }
      newHeader.push({
        name: `Motivo grua externa ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Código de servicio ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Flota ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Chofer ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Turno Servicio ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Costo ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `PVP ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Excedente ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Maniobra ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });

      for (let j = 0; j < columns?.payments; j++) {
        newHeader.push({
          name: `Servicio ${i + 1} IVA`,
          value: "",
          sortable: false,
          hide: hide,
        });
      }

      newHeader.push({
        name: `Autorizado por ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });

      newHeader.push({
        name: `Estatus de Pago ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Estatus cuenta por cobrar ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Cuenta por cobrar ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      newHeader.push({
        name: `Fecha de pago cuenta por cobrar ${i + 1}`,
        value: "",
        sortable: false,
        hide: hide,
      });
      for (let j = 0; j < columns?.payments; j++) {
        newHeader.push({
          name: `Servicio ${i + 1} Método de Pago  ${j + 1}`,
          value: "",
          sortable: false,
          hide: hide,
        });
        newHeader.push({
          name: `Servicio ${i + 1} Monto Pago  ${j + 1}`,
          value: "",
          sortable: false,
          hide: hide,
        });
        newHeader.push({
          name: `Servicio ${i + 1} Referencia de Pago  ${j + 1}`,
          value: "",
          sortable: false,
          hide: hide,
        });
        newHeader.push({
          name: `Servicio ${i + 1} Comprobante de Pago  ${j + 1}`,
          value: "",
          sortable: false,
          hide: hide,
          hidePrint: true,
        });
        if (j === columns?.payments - 1) {
          newHeader.push({
            name: `Monto Pagado ${i + 1}`,
            value: "",
            sortable: false,
            hide: hide,
          });
          newHeader.push({
            name: `Fecha Vuelto Servicio ${i + 1}`,
            value: "",
            sortable: false,
            hide: hide,
          });
          for (let k = 0; k < 3; k++) {
            newHeader.push({
              name: `Vuelto ${k + 1} $ Servicio ${i + 1}`,
              value: "",
              sortable: false,
              hide: hide,
            });
            newHeader.push({
              name: `Vuelto ${k + 1} Bs Servicio ${i + 1}`,
              value: "",
              sortable: false,
              hide: hide,
            });
            newHeader.push({
              name: `Método Vuelto ${k + 1} Servicio ${i + 1}`,
              value: "",
              sortable: false,
              hide: hide,
            });
            newHeader.push({
              name: `Referencia Vuelto ${k + 1} Servicio ${i + 1}`,
              value: "",
              sortable: false,
              hide: hide,
            });
            newHeader.push({
              name: `Comprobante de Vuelto ${k + 1} Servicio ${i + 1}`,
              value: "",
              sortable: false,
              hide: hide,
            });
          }
        }
      }
    }

    newHeader = [...newHeader, ...AddHeaderPerRole(), ...imageHeader];
    setBDHeader(newHeader);
  };

  const polutaleEmptyData = (data, services, payments) => {
    let value = "";
    let newData = [...data];
    let arreglo = [];
    for (let y = 0; y < statusHeadervalues.length; y++) {
      arreglo.push({
        name: statusHeadervalues[y],
        totalTime: "",
      });
    }

    for (let i = 0; i < newData?.length; i++) {
      if (newData[i]?.services?.length < services) {
        for (let z = newData[i]?.services?.length; z < services; z++) {
          newData[i]?.services?.push({
            productCode: value,
            code: value,
            payments: [],
            price: value,
            pvp: value,
            paymentStatus: value,
            provider: { contactName: value },
            shift: "",
            // provider: { isInternal: value },
          });
        }
      }

      for (let j = 0; j < newData[i]?.services?.length; j++) {
        // If not enough payments create empy payments
        if (newData[i]?.services[j].payments?.length < payments) {
          for (
            let k = newData[i]?.services[j].payments?.length;
            k < payments;
            k++
          ) {
            newData[i]?.services[j].payments?.push({
              method: value,
              totalAmount: value,
              reference: value,
              referenceImg: "",
            });
          }
        }

        for (let z = 0; z < newData[i]?.services[j]?.payments?.length; z++) {
          if (
            !newData[i]?.services[j]?.payments[z]?.hasOwnProperty(
              "referenceImg"
            )
          ) {
            newData[i].services[j].payments[z].referenceImg = "";
          }
        }
      }

      newData[i].newStages = arreglo;
    }
    return newData;
  };

  return (
    <>
      <LoadSpinner show={exportablesDataTable.isLoading} />
      <Header />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            TU/GRUERO: {exportablesDataTable?.count}
          </h1>
          {/* ![operationsSupervisor].includes(user?.roles?.[0]?.code) || */}
          <ActionButton
            label={"Exportar"}
            action={() => exportTable(exportablesDataTable.type)}
          />
        </div>
        <div className="breadcrumb-container">
          <div className="exportables-small-buttons-container exportables-buttons-container">
            <FilterButton
              label={"BD"}
              type={exportablesDataTable?.type}
              action={selectType}
            />
            {![operationsSupervisor].includes(user?.roles?.[0]?.code) && (
              <>
                <FilterButton
                  label={exportablesTypes?.PAYMENT_AV}
                  type={exportablesDataTable?.type}
                  action={selectType}
                />
                <FilterButton
                  label={exportablesTypes?.PAYMETN_INTERNAL_TOW}
                  type={exportablesDataTable?.type}
                  action={selectType}
                />
                <FilterButton
                  label={exportablesTypes?.PAYMENT_EXTERNAL_TOW}
                  type={exportablesDataTable?.type}
                  action={selectType}
                />
              </>
            )}
            {[operationsSupervisor, operationsAdmin].includes(
              user?.roles?.[0]?.code
            ) && (
                <FilterButton
                  label={exportablesTypes?.PAYMENT_PENDING}
                  type={exportablesDataTable?.type}
                  action={selectType}
                />
              )}
            {![operationsSupervisor].includes(user?.roles?.[0]?.code) && (
              <FilterButton
                label={exportablesTypes?.ADMINISTRATION}
                type={exportablesDataTable?.type}
                action={selectType}
              />
            )}
            <FilterButton
              label={exportablesTypes?.FOLLOW_UP}
              type={exportablesDataTable?.type}
              action={selectType}
            />
            <FilterButton
              label={exportablesTypes?.LOCKSMITH}
              type={exportablesDataTable?.type}
              action={selectType}
            />
          </div>
          <div
            style={{ width: "auto" }}
            className="exportables-buttons-container"
          >
            {!exportablesDataTable?.type && (
              <div style={{ marginTop: "12px" }} className="col-3">
                <Select
                  options={caseTypeOptions}
                  label={"Tipo de Gestion"}
                  value={exportablesDataTable?.caseType}
                  onChange={handleCaseType}
                />
              </div>
            )}
            <FilterDatePicker
              bootstrap={"col-4"}
              label={"Desde"}
              type={"date"}
              name={"untilDate"}
              placeholder={""}
              onChange={handleSinceDateChange}
              value={sinceDate}
            />{" "}
            <FilterDatePicker
              bootstrap={"col-4"}
              label={"Hasta"}
              type={"date"}
              name={"untilDate"}
              placeholder={""}
              onChange={handleUntilDateChange}
              value={untilDate}
            />
            <div style={{ marginTop: "12px" }}>
              <SelectPerPage
                label={"Registros"}
                options={itemsPerpage}
                value={exportablesDataTable?.limit}
                onChange={selectitemsPerpage}
              />
            </div>
          </div>
          <span></span>
        </div>
        {(!exportablesDataTable?.type ||
          exportablesDataTable?.type === exportablesTypes?.LOCKSMITH) && (
            <div style={{ marginRight: "12px" }}>
              <SearchInput
                placeholder={"Cédula, Placa o Código de Servicio"}
                width="260px"
                value={exportablesDataTable?.search}
                onChange={handleSearchChange}
                searchAction={getExportables}
              />
            </div>
          )}
        {!exportablesDataTable?.type && !exportablesDataTable.isLoading && (
          <ExportablesDBTable
            header={BDHeader}
            role={user?.roles[0]?.code}
            handlePageChange={handlePageChange}
            data={exportablesDataTable}
            type={exportablesDataTable?.type}
            tableRef={tableRef}
          />
        )}

        {[
          exportablesTypes?.PAYMENT_AV,
          exportablesTypes?.PAYMETN_INTERNAL_TOW,
          exportablesTypes?.PAYMENT_EXTERNAL_TOW,
        ].includes(exportablesDataTable?.type) &&
          !exportablesDataTable.isLoading && (
            <ExportablesPaymentTable
              header={AVPaymentHeader}
              handlePageChange={handlePageChange}
              data={exportablesDataTable}
              type={exportablesDataTable?.type}
              tableRef={tableRef}
            />
          )}
        {[exportablesTypes?.PAYMENT_PENDING].includes(
          exportablesDataTable?.type
        ) &&
          !exportablesDataTable.isLoading && (
            <ExportablesPendingPaymentTable
              header={PendingPaymentHeader}
              handlePageChange={handlePageChange}
              data={exportablesDataTable}
              type={exportablesDataTable?.type}
              tableRef={tableRef}
            />
          )}
        {[exportablesTypes?.ADMINISTRATION].includes(
          exportablesDataTable?.type
        ) &&
          !exportablesDataTable.isLoading && (
            <ExportableAdministrationTable
              header={AdminExportableHeader}
              handlePageChange={handlePageChange}
              data={exportablesDataTable}
              type={exportablesDataTable?.type}
              tableRef={tableRef}
            />
          )}

        {[exportablesTypes?.FOLLOW_UP].includes(exportablesDataTable?.type) &&
          !exportablesDataTable.isLoading && (
            <ExportablesFollowUpTable
              header={followUpHeader}
              handlePageChange={handlePageChange}
              data={exportablesDataTable}
              type={exportablesDataTable?.type}
              tableRef={tableRef}
            />
          )}

        {[exportablesTypes?.LOCKSMITH].includes(exportablesDataTable?.type) &&
          !exportablesDataTable.isLoading && (
            <ExportablesLocksmithTable
              header={locksmithHeader}
              handlePageChange={handlePageChange}
              data={exportablesDataTable}
              type={exportablesDataTable?.type}
              tableRef={tableRef}
            />
          )}
      </div>
    </>
  );
};
